.agreementActivitesWarningModal {
  max-width: 95vw;
}
